module.exports = __webpack_public_path__ + "static/Cheerego7-0b3b7c6b1921e39e5286c609bf6b0983.png";